import { beforeEnterMaterial as beforeEnter } from '@/views/contratos-originacao/material/routes/beforeRouter';

const routes = [
    {
        path: '/materiais',
        name: 'ConfiguracaoMaterial',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import('@/views/contratos-originacao/material/views/ConfiguracaoMaterial')
    },
    {
        path: '/materiais/cadastro',
        name: 'CadastroMaterial',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import('@/views/contratos-originacao/material/views/FormularioMaterial')
    },
    {
        path: 'materiais/editar/:id',
        name: 'EditarVisualizarMaterial',
        meta: {
            roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
        },
        component: () =>
            import(
                '@/views/contratos-originacao/material/views/FormularioMaterial'
            )
    },
    {
        path: 'materiais/detalhes/:id',
        name: 'DetalhesMaterial',
        meta: {
            roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
        },
        component: () =>
            import(
                '@/views/contratos-originacao/material/views/DetalhesMaterial'
            )
    }
];

export default routes;
